// noinspection ES6UnusedImports
import React from 'react';
import Feedback from "./Feedback.jsx";
import ReviewRating from "./ReviewRating.jsx";
import {Typography} from '@bonprix/design-system';

export default function Review({review, isLoggedIn, loginLink, texts}) {
    const {
        complained,
        id,
        positiveFeedbackCount,
        negativeFeedbackCount,
        name,
        createdAtFormatted,
        content,
        attributesString,
        rating,
        imported,
        ownReview
    } = review;

    return (
        <div className={'review' + (complained ? ' is-reported' : '')}>
            <div className="review__headline">
                <div className="review__rating">
                    <ReviewRating rating={rating} ratingClass="reviews__rating-star" />
                    <div className="review__author">
                        <div><Typography variant="h5">{name}</Typography></div>
                        {imported && (
                            <div><Typography variant="body1">{texts.ada_review_imported_from}</Typography></div>
                        )}
                    </div>
                </div>
                <Typography variant="body2" color="on-bg-low">{createdAtFormatted}</Typography>
            </div>
            <div className="review__text">
                <Typography variant="body1">{content}</Typography>
            </div>
            <Typography variant="body2">{attributesString}</Typography>
            {ownReview ?
                null :
                <div className="review__feedback">
                    <Feedback
                        texts={texts}
                        reviewId={id}
                        loggedIn={isLoggedIn}
                        loginLink={loginLink}
                        complained={complained}
                        positiveFeedbackCount={positiveFeedbackCount}
                        negativeFeedbackCount={negativeFeedbackCount}
                    />
                </div>
            }
        </div>
    );
}
